import { MODULE_PREFIX } from '../constants';
import { FormState } from '../types';

export const formStateSelector = (state, form: string): FormState => state[MODULE_PREFIX][form];
